import React from "react";
import {
  Service,
  WeatherStationStates,
  stationViewUiHelper,
} from "@helpers/ui_helper";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteWeatherStation } from "../../../services/api";
import { Button } from "antd";
import {
  EditOutlined,
  CloseOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import StationServiceChecker from "./StationServiceChecker";
import { CustomMarker } from "../../../components/map/utils/customs";
import { toolbarBaseControls } from "../../../features/map/utils/configs";
import AgroMapPoint from "../../../features/map/presentation/components/AgroMapPoint";
import Swal from "sweetalert2";

function StationView({ weatherStation, setWeatherStationState, index }) {
  const queryClient = useQueryClient();

  const deleteStationMutation = useMutation(deleteWeatherStation, {
    onSuccess: () => {
      queryClient.invalidateQueries(["weatherStations"]);
    },
  });

  const stationData = stationViewUiHelper(weatherStation);

  return (
    <>
      {!stationData.isEnabled && !stationData.processing && (
        <div className="flex animate-pulse p-3 bg-[#FBF199] justify-start items-center gap-1 -mb-6 rounded-xl">
          <WarningOutlined className="text-red-600 text-lg" />
          <div className="text-right text-[#111111] max-lg:text-xs">
            ایستگاه شما با موفقیت ثبت شده است. فعالسازی ایستگاه مستلزم پرداخت
            هزینه می‌باشد.
          </div>
        </div>
      )}

      {!stationData.isEnabled && stationData.processing && (
        <div className="flex animate-pulse p-3 bg-[#FBF199] justify-start items-center gap-1 -mb-6 rounded-xl">
          <WarningOutlined className="text-red-600 text-lg" />
          <div className="text-right text-[#111111] max-lg:text-xs">
            ایستگاه هواشناسی شما تا 2 ساعت آینده فعال خواهد شد. فعالسازی از طریق
            پیامک اطلاع رسانی می‌شود.
          </div>
        </div>
      )}

      <div className="Component p-4 max-lg:p-2 box-shadow agrobg rounded-[16px] max-lg:w-fit justify-between items-center flex max-lg:flex-col-reverse">
        <div className="Right self-stretch w-[24rem] max-lg:w-[15rem] px-6 max-lg:px-0 flex-col justify-between items-center gap-6 flex">
          <div className="flex flex-col w-full h-full pt-4 max-lg:gap-2 justify-between items-center">
            <div className="w-full justify-between items-center flex">
              <p className=" text-right text-zinc-700 text-lg max-lg:text-xs font-medium w-[120px]">
                نام ایستگاه:
              </p>
              <p className=" text-right text-zinc-500 text-base max-lg:text-sm font-medium ">
                {stationData?.name}
              </p>
            </div>

            <div className="Frame2 w-full justify-between items-center flex">
              <p className=" text-right text-zinc-700 text-lg max-lg:text-xs font-medium w-[120px]">
                استان:
              </p>
              <p className=" text-right text-zinc-500 text-base max-lg:text-sm font-medium ">
                {stationData?.province?.name}
              </p>
            </div>
            <div className="Frame3 w-full justify-between  items-center flex">
              <p className=" text-right text-zinc-700 text-lg max-lg:text-xs font-medium w-[120px]">
                شهر:
              </p>
              <p className=" text-right text-zinc-500 text-base max-lg:text-sm font-medium ">
                {stationData?.city?.name}
              </p>
            </div>
            <div className="Frame4 w-full justify-between  items-center flex">
              <p className=" text-right text-zinc-700 text-lg max-lg:text-xs font-medium w-[120px]">
                منطقه:
              </p>
              <p className=" text-right text-zinc-500 text-base max-lg:text-sm font-medium ">
                {stationData?.zone}
              </p>
            </div>
            <div className="Frame4 w-full justify-between  items-center flex">
              <p className=" text-right text-zinc-700 text-lg max-lg:text-xs font-medium w-[120px]">
                نقطه GPS:
              </p>
              <p className=" text-right text-zinc-500 text-base lg:whitespace-nowrap max-lg:text-sm font-medium ">
                {stationData?.location[1]?.toFixed(4)} ,
                {stationData?.location[0]?.toFixed(4)}
              </p>
            </div>
          </div>

          {stationData?.isEnabled || stationData?.processing ? (
            <Button
              disabled={stationData?.processing}
              className="SeeStation hover:brightness-110 !border-slate-200 text-center h-[42px] !text-white text-xl font-bold px-[8rem]  py-1 button-green justify-center max-lg:justify-around items-center gap-1 flex cursor-pointer"
              onClick={() =>
                setWeatherStationState({
                  service: Service.Weather,
                  state: WeatherStationStates.Station,
                  stationObject: weatherStation,
                })
              }
            >
              مشاهده
            </Button>
          ) : (
            <Button
              className="SeeStation text-center h-[42px] hover:brightness-110 !border-slate-200 !text-white text-xl font-bold px-[6rem] py-1 button-green justify-center  max-lg:justify-around items-center gap-1 flex cursor-pointer"
              onClick={() =>
                setWeatherStationState({
                  service: Service.Weather,
                  state: WeatherStationStates.StationPayment,
                  stationObject: weatherStation,
                })
              }
            >
              پرداخت و فعالسازی
            </Button>
          )}
        </div>
        <div className="Map flex-col justify-start items-center gap-4 inline-flex">
          <div className="Top relative overflow-hidden rounded-lg border-2 border-slate-300 flex-col justify-center items-center flex">
            <div className="THISISFORMAPLOCK! !z-[999999999] bg-transparent w-full h-full absolute" />
            <div
              className={`max-lg:!w-[16rem] max-lg:h-[16rem] w-[300px] h-[260px]
             opacity-70 pointer-events-none`}
            >
              <AgroMapPoint
                key={stationData.id}
                type="onlyShow"
                mapId={stationData.id}
                markerIcon={CustomMarker}
                toolbarOptions={toolbarBaseControls}
                currentPoint={stationData.location}
              />
            </div>
            {stationData.isEnabled && !stationData.processing && (
              <div className="Frame2070 z-[1] w-[270px] py-0.5 top-6 left-[-4rem] rotate-[-25deg] bg-black bg-opacity-50 justify-center items-center gap-2 absolute flex">
                <div className="text-right text-neutral-200 text-2xl font-semibold">
                  فعال
                </div>
                <div className="Ellipse89 animate-pulse blur-[1px] w-5 h-5 bg-gradient-to-br from-green-600 to-green-500 rounded-full shadow" />
              </div>
            )}

            {!stationData.isEnabled && !stationData.processing && (
              <div className="Frame2070 z-[1] w-[270px] py-0.5 top-6 left-[-4rem] rotate-[-25deg] bg-black bg-opacity-50 justify-center items-center gap-2 absolute flex">
                <div className="text-right text-neutral-200 text-2xl font-semibold">
                  غیر فعال
                </div>
                <div className="Ellipse89 w-5 h-5 bg-gradient-to-br from-red-700 to-red-600 rounded-full shadow" />
              </div>
            )}

            {!stationData.isEnabled && stationData.processing && (
              <div className="Frame2070 z-[1] w-[270px] py-0.5 top-6 left-[-4rem] rotate-[-25deg] bg-black bg-opacity-50 justify-center items-center gap-2 absolute flex">
                <div className="text-right text-neutral-200 text-xl font-semibold">
                  در حال پردازش
                </div>
                <div className="Ellipse89 animate-pulse blur-[1px] w-5 h-5 bg-gradient-to-br from-yellow-300 to-yellow-400 rounded-full shadow" />
              </div>
            )}
          </div>

          {stationData.isEnabled || stationData.processing ? (
            <StationServiceChecker data={weatherStation} />
          ) : (
            <div className="Bottom  justify-center items-start gap-3.5 inline-flex">
              <Button
                icon={<EditOutlined />}
                className="Edit text-center hover:brightness-[0.98] !text-zinc-700 lg:text-xl font-semibold w-[150px] max-lg:!w-[130px] px-2 py-2 button-neo2 justify-center items-center gap-2.5 flex cursor-pointer"
                onClick={() =>
                  setWeatherStationState({
                    service: Service.Weather,
                    state: WeatherStationStates.MapPoint,
                    stationObject: weatherStation,
                  })
                }
              >
                ویرایش
              </Button>

              <Button
                loading={deleteStationMutation.isLoading}
                danger
                icon={<CloseOutlined />}
                className="Cancel text-center hover:brightness-[0.98] !text-red-400 lg:text-xl font-semibold w-[150px] max-lg:!w-[130px] px-8 py-2 button-neo2 justify-center items-center gap-2.5 flex cursor-pointer"
                onClick={() =>
                  Swal.fire({
                    title: "حذف ایستگاه",
                    text: "آیا از حذف ایستگاه مطمئن هستید؟",
                    icon: "error",
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: "تایید",
                    cancelButtonText: "لغو",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      deleteStationMutation.mutate(weatherStation?.id);
                    }
                  })
                }
              >
                حذف
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default StationView;
